export default __webpack_public_path__ + "static/media/newsletter.8c25085b.svg";